import type { TColor } from '@Theme';
import OwnableTheme from '@Theme';
import type { FC } from 'react';
import React from 'react';
import type { StyleProp, TextStyle } from 'react-native';

import type { Size, Weight } from '../../Common/Text';
import { Text } from '../../Common/Text';

type ProductPriceLabelProps = {
  priceLabel: string | undefined;
  weight?: Weight;
  size?: Size;
  gutterBottom?: number;
  color?: TColor;
};

const labelStyle: StyleProp<TextStyle> = {
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'center',
  height: '100%',
  justifyContent: 'center',
  flexDirection: 'column',
};

const ProductPriceLabel: FC<ProductPriceLabelProps> = ({
  weight = 'regular',
  priceLabel,
  color = OwnableTheme.colors.persianIndigo,
  size = 'ml',
}) => (
  <>
    {priceLabel !== undefined && (
      <Text
        weight={weight}
        size={size}
        color={color}
        fontStyleOverride={labelStyle}
      >
        {priceLabel}:{' '}
      </Text>
    )}
  </>
);

export default ProductPriceLabel;
